import React from 'react';
import clsx from 'clsx';

import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import Typography from '@smart-tv/components/typography/typography';
import testIds from '@smart-tv/e2e/shared/variables';
import { UIElement } from '@smart-tv/typings/content';
import styles from '../stripes.module.scss';
import { IS_BROWSER } from '@smart-tv/utils/is-browser';

export const getLayoutClass = (uiElementStyleName: string): string => {
  switch (uiElementStyleName) {
    case 'UNIVERSE_MOVIES':
    case 'PROGRAM_PORTRAIT':
    case 'PORTRAIT':
      return 'portrait';

    case 'PROGRAM_CHANNEL':
      return 'wide-landscape';

    /*
      Cases that should revert to default
      case 'UNIVERSE_SERIE':
      case 'PROGRAM_LANDSCAPE':
      case 'LANDSCAPE':
      case 'UNIVERSE_MIXED':
    */
    default:
      return 'landscape';
  }
};

interface Props {
  show: boolean;
  handleShowAllEnterPress: (uiElement?: UIElement) => void;
  uiElementStyleName?: string;
  focusKey?: string;
}

export const StripesShowAllItem: React.FC<Props> = (props: Props) => {
  const { show, handleShowAllEnterPress, uiElementStyleName, focusKey } = props;

  const handleEnterPress = React.useCallback(() => {
    handleShowAllEnterPress();
  }, [handleShowAllEnterPress]);

  const { ref, focused } = useFocusable({
    onEnterPress: handleEnterPress,
    focusKey: focusKey
  });

  if (!show) return null;

  return (
    <div
      className={clsx(styles['show-all'], { [styles['show-all--focused']]: focused })}
      onClick={IS_BROWSER ? handleEnterPress : undefined}
    >
      <div
        data-testid={testIds.contentSlider.actions.showAll}
        ref={ref}
        className={clsx(
          styles['border'],
          styles[`border--${getLayoutClass(uiElementStyleName ?? '')}`],
          { [styles['border--focused']]: focused }
        )}
      >
        <Typography className={styles['content']} variant="h3">
          Vis alle
        </Typography>
      </div>
    </div>
  );
};

export default React.memo(StripesShowAllItem);
